import { userPartialUpdaterBuilder } from "../userPartialUpdaterBuilder";
import { TimezoneFormik, TIMEZONE_MESSENGER_CONTEXT, validationTimezoneSchema } from "./TimezoneForm";

export const TimezoneEdit = userPartialUpdaterBuilder(TimezoneFormik, {
  validationSchema: validationTimezoneSchema,
  messangerContext: TIMEZONE_MESSENGER_CONTEXT,
});
